import React from 'react';
//import ReactGA from 'react-ga'
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom'
import './index.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';


// Initialize Google Analytics and track first page view
//ReactGA.initialize('UA-145948854-1');
//ReactGA.pageview(window.location.pathname);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<HashRouter>
	  <App />
	</HashRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();